import React from 'react'
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import {
    bindMenu,
} from 'material-ui-popup-state/hooks'


export default function HoverMenuComponent({ popupState, menuPaperClassName, children, anchorOrigin = { vertical: "bottom", horizontal: "center" }, transformOrigin = { vertical: "top", horizontal: "center" } }) {
    return (
        <HoverMenu
            {...bindMenu(popupState)}
            PaperProps={{
                className: menuPaperClassName
            }}
            variant='menu'
            elevation={8}
            transitionDuration={0}
            getContentAnchorEl={null}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
        >
            {children}
        </HoverMenu>
    )
}
